<template>
  <v-card class="mb-2 cursor-pointer" rounded="xl" style="max-width: 350px">
    <div
      class="d-flex align-center pa-3"
      :class="$vuetify.theme.global.name === 'dark' ? 'bg-grey-darken-4' : 'bg-grey-lighten-4'"
      style="width: 100%"
    >
      <div class="text-h6">
        <span v-if="element.bookingItem">
          {{ element.bookingItem.name || "Unbekannt" }}
        </span>
      </div>

      <div class="flex-grow-1"></div>

      <v-menu offset-y>
        <template #activator="{ props }">
          <v-btn icon variant="text" v-bind="props">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>

        <v-list density="compact">
          <v-list-item
            @click="onOpenBooking(element.bookingItem.id)"
            prepend-icon="mdi-information"
          >
            <v-list-item-title>Buchungsdetails anzeigen</v-list-item-title>
          </v-list-item>

          <v-divider />

          <v-list-item
            @click="onOpenEditBooking(element.bookingItem.id)"
            prepend-icon="mdi-pencil"
          >
            <v-list-item-title>Buchung bearbeiten</v-list-item-title>
          </v-list-item>

          <v-list-item
            @click="commitBooking(element.bookingItem.id)"
            prepend-icon="mdi-checkbox-marked-circle"
          >
            <v-list-item-title>Buchung freigeben</v-list-item-title>
          </v-list-item>

          <v-list-item
            @click="archiveTask(element.id)"
            prepend-icon="mdi-archive"
          >
            <v-list-item-title>Buchung archivieren</v-list-item-title>
          </v-list-item>

          <v-list-item
            v-if="!backlog"
            @click="
              moveTask(
                { added: { element: { id: element.id }, newIndex: 0 } },
                'backlog'
              )
            "
            prepend-icon="mdi-database"
          >
            <v-list-item-title>In Backlog verschieben</v-list-item-title>
          </v-list-item>

          <v-divider />

          <v-list-item
            @click="rejectBooking(element.id)"
            prepend-icon="mdi-close-circle"
          >
            <v-list-item-title>Buchung stornieren</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>

    <v-card-text v-if="element.bookingItem">
      <v-row no-gutters>
        <v-col>
          {{ element.bookingItem.bookableItems[0]?._bookableUsed?.title }}
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col> Buchungsnummer: {{ element.bookingItem?.id }} </v-col>
      </v-row>
    </v-card-text>

    <v-card-actions>
      <div class="flex-grow-1"></div>
      <v-tooltip location="top">
        <template #activator="{ props }">
          <div v-bind="props">
            <v-rating
              v-if="!backlog"
              class="me-4 small-rating"
              empty-icon="mdi-circle-outline"
              full-icon="mdi-circle"
              readonly
              length="4"
              size="x-small"
              density="comfortable"
              background-color="purple lighten-3"
              :color="
                durationInStatus(element.added) >= 4
                  ? 'error'
                  : durationInStatus(element.added) >= 2
                  ? 'warning'
                  : 'success'
              "
              :model-value="durationInStatus(element.added)"
            />
          </div>
        </template>
        <span>
          Die Buchung befindet sich seit {{ durationInStatus(element.added) }}
          {{ durationInStatus(element.added) === 1 ? "Tag" : "Tagen" }} in
          diesem Status
        </span>
      </v-tooltip>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "BookingKanbanCard",
  props: {
    element: Object,
    backlog: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    durationInStatus(dateAdded) {
      const now = Date.now();
      const diff = now - dateAdded;
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      return days;
    },

    onOpenBooking(bookingId) {
      this.$emit("open-booking", bookingId);
    },
    onOpenEditBooking(bookingId) {
      this.$emit("open-edit-booking", bookingId);
    },
    commitBooking(bookingId) {
      this.$emit("commit-booking", bookingId);
    },
    rejectBooking(bookingId) {
      this.$emit("reject-booking", bookingId);
    },
    archiveTask(taskId) {
      this.$emit("archive-task", taskId);
    },
    moveTask(event, status) {
      this.$emit("move-task", event, status);
    },
  },
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>
